export default "__VITE_ASSET__eFtI3h0X__"